<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h1 class="u">
      Детали заявки
      <router-link class="btn btn-primary" :to="{ name: 'claim-edit', params: { id: claim.id }}">Редактировать информацию</router-link>
    </h1>
    <div class="sub-nav">
      <router-link class="btn btn-default btn-sm" :to="{ name: 'claims' }">← Назад к Заявкам</router-link>
    </div>

    <div class="row">
      <div class="col-md-6">

        <!-- Full name -->
        <div class="form-group">
          <label>Клиент</label>
          <p>{{ claim.full_name }}</p>
        </div>

        <!-- Text -->
        <div class="form-group">
          <label>Текст заявки</label>
          <p>{{ claim.text }}</p>
        </div>

        <!-- Datetime -->
        <div class="form-group">
          <label>Дата и время</label>
          <p>{{ formatDate(claim.datetime) }}</p>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import { getClaim } from '@/services/claim.service'
import helpers from '@/helpers'

export default {
  name: 'client-details',
  data () {
    return {
      claim: {
        id: null,
        text: '',
        datetime: '',
        full_name: ''
      }
    }
  },
  mounted () {
    if (this.$route.params.id !== undefined) {
      this.claim.id = this.$route.params.id

      getClaim(this.claim.id).then((response) => {
        this.claim = response.data
      })
    }
  },
  methods: {
    formatDate: helpers.formatDate
  }
}
</script>


// WEBPACK FOOTER //
// ClaimDetails.vue?54004dc2